import { useCallback } from 'react';
import { useVeloClient } from '@wix/velo-client';
import {
  DeploymentStatus,
  useDocumentManagementClient,
} from '@wix/document-management-client';
import type { DeploymentSourceTypes } from '../gridapp/deployApp.js';
import {
  getDeploymentSourceData,
  DeploymentSource,
} from '../gridapp/deployApp.js';
import { useProjectModel } from '../model.js';

export function useCreatePreview() {
  const { model } = useProjectModel();
  const veloClient = useVeloClient();
  const dmClient = useDocumentManagementClient();

  return useCallback(
    async (previewSource: DeploymentSourceTypes) => {
      const deploymentSourceData = await getDeploymentSourceData(
        model,
        previewSource === 'local'
          ? DeploymentSource.local()
          : DeploymentSource.remote()
      );

      const preview = await veloClient.deploySitePreview(deploymentSourceData);

      return {
        deploymentId: preview.deploymentId,
        previewUrl: preview.deploymentShortUrl ?? preview.deploymentUrl,
        deploymentStatus: preview.isPublishPipelineDeployment
          ? await dmClient.getDeploymentDetails(preview.deploymentId)
          : DeploymentStatus.Success(),
      };
    },
    [dmClient, model, veloClient]
  );
}
